export class LoanOfficersManagementApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanManagement() {
    return this.#http.get('/LoanManagement');
  }

  async createLoanManagement(body) {
    return this.#http.post('/LoanManagement', body);
  }

  async deleteLoanManagement({ ownerId, dependentId }) {
    return this.#http.delete(`/LoanManagement/${ownerId}/${dependentId}`);
  }
}
